import { render, staticRenderFns } from "./ConfiguracaoIA.vue?vue&type=template&id=03c8c712&scoped=true"
import script from "./ConfiguracaoIA.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoIA.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoIA.vue?vue&type=style&index=0&id=03c8c712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c8c712",
  null
  
)

export default component.exports